import { FaqItem } from '../content/faq';
import { CONTENT_INDEX } from './content-index.generated';
import { ContentIndex, ContentIndexEntry, FaqEntry } from './content-types';

// Bu dosya eager yüklenir (alt bilgi, lansman): sayfa modüllerini (pages/*.generated.ts) ASLA import etmez.

export interface HubLink {
  readonly label: string;
  readonly path: string;
}

/// Alt bilgi "Ürün" menüsü: dizin bağlantısı yalnız o dizin bu derlemede varsa (boş dizin gizli).
export function hubFooterLinks(content: ContentIndex = CONTENT_INDEX): readonly HubLink[] {
  return [
    ...(content.featureIndex ? [{ label: 'Özellikler', path: content.featureIndex.path }] : []),
    ...(content.guideIndex ? [{ label: 'Rehber', path: content.guideIndex.path }] : []),
  ];
}

/// Savunma: üretim dizininde taslak kayıt olmamalı (derleme kapısı); yine de olursa bağlantı verilmez.
const linkable = (content: ContentIndex, entry: ContentIndexEntry): boolean => content.mode === 'drafts' || !entry.draft;

/// Lansman "Özellikler" bloğu (FEATURES id'si) → yayımlanan özellik sayfası.
export function landingFeatureLink(blockId: string, content: ContentIndex = CONTENT_INDEX): string | null {
  return content.features.find((f) => f.landingBlock === blockId && linkable(content, f))?.path ?? null;
}

/// Lansman "Kim için?" kartı (AUDIENCES id'si) → yayımlanan kitle sayfası.
export function audienceCardLink(cardId: string, content: ContentIndex = CONTENT_INDEX): string | null {
  return content.audiences.find((a) => a.audienceCard === cardId && linkable(content, a))?.path ?? null;
}

export function toFaqItems(faq: readonly FaqEntry[]): FaqItem[] {
  return faq.map((f, i) => ({ id: `s${i + 1}`, question: f.question, answer: f.answer, placements: [] }));
}

const MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/// 'YYYY-AA-GG' → '6 Ekim 2026' (sunucu/istemci aynı sonuç; yerel ayar kaydı gerekmez).
/// Biçimsiz girdi (şema zaten reddeder) "undefined NaN" yerine olduğu gibi döner.
export function formatTrDate(iso: string): string {
  const match = ISO_DATE.exec(iso);
  if (!match) return iso;
  const [y, m, d] = match.slice(1).map(Number);
  if (m < 1 || m > 12 || d < 1 || d > 31) return iso;
  return `${d} ${MONTHS[m - 1]} ${y}`;
}
